import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
  createActivityChangeExtension,
} from '@spotify/plugin-confidence-activity-react';

import { getWorkflowLabel } from '../helpers';
import { getActionTitle, getStateLabel } from './stateLabels';

const StateChangeRender = ({ change }: ActivityChangeOptions) => {
  return (
    <ActivityItem.Section label="Updated state">
      <ActivityTagItem
        oldValue={getStateLabel(change.oldValue)}
        newValue={getStateLabel(change.newValue)}
      />
    </ActivityItem.Section>
  );
};

export const STATE_CHANGE_EXTENSION = createActivityChangeExtension({
  id: 'state-change',
  priority: 10,
  predicate: ({ change }) => change.fieldPath === '/state',
  title: (change, options) => {
    const workflowLabel = getWorkflowLabel(options?.activity.primaryResource);
    return getActionTitle(change.oldValue, change.newValue, workflowLabel);
  },
  render: StateChangeRender,
  values: change => ({
    oldValue: { state: change.oldValue },
    newValue: { state: change.newValue },
  }),
});
